var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconMap = function SvgIconMap(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 48 49"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M39 11.198V36.74l-10.5 1.75-9-1.5L9 38.74V13.198l10.5-1.75 9 1.5zm-18 23 6 1v-14.73h3v14.73l6-1V14.74l-7.5 1.25-9-1.5-7.5 1.25v19.458l6-1v-15.23h3z",
    clipRule: "evenodd"
  })));
};
export default SvgIconMap;